import { registerOpenModal } from 'src/widgets/embed/openModal'

// Side-effect module: registers a local `share:*` handler that opens
// the inline Bootstrap 5 share modal (#shareModal in _share.html.erb)
// when the donate widget is the top frame OR the channel handshake
// to a parent fails (improperly-embedded mode 3). In modes 2 + 3 with
// a working channel the same `share:*` envelope bubbles upward to the
// FLP — which has its own copy of #shareModal at the FLP page level
// and registers `share:*` itself — or, when no upstream level
// intercepts, falls through to the openModal default (renderModal
// iframe at the host page).
//
// The handler is registered unconditionally: openModal only consults
// the local registry on its renderLocal branch (top-frame and
// channel-fallback), so this handler can't accidentally fire when a
// proper channel handshake routes the open upward.
registerOpenModal('share:*', () => {
  const element = document.getElementById('shareModal')
  if (!element) throw new Error('No #shareModal element to open')
  bootstrap.Modal.getOrCreateInstance(element).show()
})
